// Load audio players
window.addEventListener('load', function() {
    var players = document.querySelectorAll('.placeholder-player');
    var playerTemplate = document.querySelector('#template-audio-player');
    for(const placeholder of players) {
        var playerInstance = playerTemplate.content.firstElementChild.cloneNode(true);
        placeholder.after(playerInstance);

        console.log(playerInstance);
        initAudioPlayer(playerInstance, placeholder.getAttribute('data-url') + getMemberParams(), placeholder.getAttribute('data-title'));
        placeholder.remove();
    }
});

/** @deprecated */
function player() {
    alert("Questa pagina include un player audio in un formato vecchio e non supportato. Si prega di sostituirlo");
}

var players = new Map();

function initAudioPlayer(playerElement, url, title) {
    'use strict';
    var playerAudio = playerElement.querySelector('.player-audio');
    var playerMedia = playerElement.querySelector('.post-media');
    var playerThumbnail = playerElement.querySelector('.post-image');
    var playerTitle = playerElement.querySelector('.player-title');
    var playerMeta = playerElement.querySelector('.post-meta');
    var playerProgress = playerElement.querySelector('.player-progress');
    var playerSpeed = 1;
    var buttonPlay = playerElement.querySelector('.button-play');
    var buttonBackward = playerElement.querySelector('.player-button-backward');
    var buttonForward = playerElement.querySelector('.player-button-forward');
    var buttonSpeed = playerElement.querySelector('.player-button-speed');
    var buttonClose = playerElement.querySelector('.player-button-close');
    var buttonDownload = playerElement.querySelector('.player-button-download');
    var timeCurrent = playerElement.querySelector('.player-time-current');
    var timeDuration = playerElement.querySelector('.player-time-duration');


    playerElement.classList.remove('hidden');
    playerTitle.textContent = title;
    playerAudio.src = url;
    playerAudio.load();

    function togglePlay(recursePause = true) {
        setDuration();

        if (playerAudio.paused && recursePause) {
            // Pause all other players
            if(recursePause) players.forEach(a => { if(a != playerAudio) a.togglePlay(false) });

            playerAudio.play();
        } else {
            playerAudio.pause();
        }
    }

    function setDuration() {
        var duration = new Date(playerAudio.duration * 1000).toISOString().substr(11, 8);
        console.log('duration: ' + duration);
        timeDuration.textContent = duration;
    }


    buttonPlay.addEventListener('click', togglePlay);
    playerAudio.togglePlay = togglePlay;

    playerAudio.addEventListener('play', function () {
        buttonPlay.classList.add('is-playing');
    });

    playerAudio.addEventListener('pause', function () {
        buttonPlay.classList.remove('is-playing');
    });

    // Set total time
    playerAudio.addEventListener('loadedmetadata', function () {
        console.log('metadata loaded');

        setDuration();
    });

    // Update position time
    playerAudio.addEventListener('timeupdate', function (e) {
        timeCurrent.textContent = new Date(e.target.currentTime * 1000).toISOString().substr(11, 8);
        
        $(playerProgress).css(
            'width',
            (e.target.currentTime / playerAudio.duration) * 100 + '%'
        );
    });

    buttonBackward.addEventListener('click', function () {
        playerAudio.currentTime = playerAudio.currentTime - 10;
    });

    buttonForward.addEventListener('click', function () {
        playerAudio.currentTime = playerAudio.currentTime + 30;
    });

    var speedSelector = 0;
    var playbackSpeeds = [1.0, 1.5, 2.0, 0.5];
    buttonSpeed.addEventListener('click', function () {
        speedSelector = (speedSelector + 1) % playbackSpeeds.length;
        playerSpeed = playbackSpeeds[speedSelector];

        playerAudio.playbackRate = playerSpeed;
        buttonSpeed.textContent = playerSpeed + 'x';
    });

    buttonDownload.addEventListener('click', function () {
        console.log('download')
        var link = document.createElement("a");
        link.download = title+'.mp3';
        link.href = url;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        link.remove();
    });

    // Add player to list
    players.set(title, playerAudio);
}